import styled, { DefaultTheme } from 'styled-components';
import Typography from '../typography';

export function getFileColor(theme: DefaultTheme, mime: string) {
  switch (mime) {
    case 'image':
      return theme.color.solid.accent;
    default:
      return theme.color.tint.primary;
  }
}

export const FilePreviewSC = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const FileName = styled(Typography)`
  color: ${({ theme }) => theme.color.tint.primary};
  word-break: break-word;

  &.clickable:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .ui-file-preview-error & {
    color: ${({ theme }) => theme.color.tint.error};
  }

  .ui-file-preview-success &,
  .ui-file-preview-success & {
    color: ${({ theme }) => theme.color.solid.success};
  }
`;

export const FileMime = styled(Typography)`
  position: absolute;
  top: 21px;
  left: 2px;

  width: 28px;

  color: ${({ theme }) => theme.color.surface.baseline};
  text-align: center;
`;

export const FilePreviewListSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FileNameCenter = styled.div`
  flex: 1;
  margin-left: 16px;
  transition: all 0.2s;

  .progress-track {
    width: 100%;
    height: 2px;

    margin-top: 4px;

    border-radius: 2px;
    background: ${({ theme }) => theme.color.surface.elevation2};
    transition: all 0.2s;

    .progress {
      height: 2px;
      background: ${({ theme }) => theme.color.solid.info};
      border-radius: 2px;
    }
  }
`;

export const ImagePreview = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 6px;
  object-fit: contain;
`;
